// extracted by mini-css-extract-plugin
export default {"renameIcon":"TagsModalContent-renameIcon-p0YsH","message":"TagsModalContent-message-XHnCK","result":"TagsModalContent-result-SDxiV"};